module.exports = "<p>\n  escal-suivi-gestion-media works!\n</p>\n"